import { render, staticRenderFns } from "./UpdateFormModal.vue?vue&type=template&id=34fc5bff&scoped=true&lang=pug"
import script from "./UpdateFormModal.vue?vue&type=script&lang=js"
export * from "./UpdateFormModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateFormModal.vue?vue&type=style&index=0&id=34fc5bff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc5bff",
  null
  
)

export default component.exports